export default __webpack_public_path__ + "static/muted-956bd6c2eefbe7f7171b6c22d4bdb883.png";